var exports = {};
class Sleeper {
  constructor() {}
  sleep(seconds) {
    return new Promise(resolve => setTimeout(resolve, seconds * 1000));
  }
}
exports = Sleeper;
export default exports;